import { render, staticRenderFns } from "./SecondaryMarketAutomaticBadDebt.vue?vue&type=template&id=55d9641b&scoped=true"
import script from "./SecondaryMarketAutomaticBadDebt.vue?vue&type=script&lang=js"
export * from "./SecondaryMarketAutomaticBadDebt.vue?vue&type=script&lang=js"
import style0 from "./SecondaryMarketAutomaticBadDebt.vue?vue&type=style&index=0&id=55d9641b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9641b",
  null
  
)

export default component.exports